export default {
  labels: {
    dont_have_account: 'Don’t have an account? ',
  },
  title: 'Join {{name}}!',
  default_program_name: 'Rewards Club',
  buttons: {
    sign_up: 'Sign up',
  },
};
